<template>
    <div class="crash">
        <div class="crash-banner-section">
            <div class="crash-title-container">
                <h1 class="crash-title">CRASH</h1>
                <p class="crash-subtitle">Watch it rise. Exit in time.</p>
            </div>
            <img src="@/assets/img/christmas/crashBanners.jpg" alt="Crash Banner" class="crash-banner" />
        </div>
        <div class="crash-container">
            <transition name="fade" mode="out-in">
                <div v-if="socketCrash.connected === false" class="container-loading" key="loading">
                    <div class="loading-element"></div>
                    <div class="loading-element"></div>
                </div>
                <div v-else class="container-data" key="data">
                    <CrashControls />
                    <div class="data-left">
                        <CrashGame />
                        <CrashHistory />
                    </div>
                </div>
            </transition>
        </div>


        <Bets v-if="!isMobile" />
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import Bets from '@/components/bets/Bets';
    import CrashGame from '@/components/crash/CrashGame';
    import CrashHistory from '@/components/crash/CrashHistory';
    import CrashControls from '@/components/crash/CrashControls';
    import Payment from '@/components/Payment';

    export default {
        name: 'Crash',
        metaInfo: {
            title: 'Crash'
        },
        components: {
            Bets,
            CrashGame,
            CrashHistory,
            CrashControls,
            Payment
        },
        methods: {
            ...mapActions(['socketConnectCrash', 'socketDisconnectCrash'])
        },
        data() {
            return { isMobile: false, _resizeHandler: null };
        },
        computed: {
            ...mapGetters(['socketCrash']),
        },
        mounted() {
            this._resizeHandler = () => { this.isMobile = window.innerWidth <= 950; };
            this._resizeHandler();
            window.addEventListener('resize', this._resizeHandler);
        },
        beforeDestroy() {
            if (this._resizeHandler) {
                window.removeEventListener('resize', this._resizeHandler);
            }
        },
        created() {
            this.socketConnectCrash();
            this.isMobile = typeof window !== 'undefined' && window.innerWidth <= 950;
        },
        beforeRouteLeave(to, from, next) {
            this.socketDisconnectCrash();
            next();
        }
    }
</script>

<style scoped>
    .crash {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
/*padding: 45px 10px;*/
        min-height: 100vh;
    }

    .crash-banner-section {
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        padding: 0 100px;
    }

    .crash-title-container {
        position: absolute;
        left: 100px;
        top: 0;
        z-index: 2;
        display: flex;
        align-items: baseline;
        gap: 20px;
        flex-wrap: nowrap;
        margin: 90px 0 0 45px;
    }

    .crash-title {
        font-family: 'Anton SC', sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 64px;
        line-height: 69px;
        letter-spacing: 0%;
        color: var(--gradient-txt-yellow);
        background: var(--gradient-txt-yellow);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        margin: 0;
        padding: 0;
        white-space: nowrap;
        display: inline-block;
    }

    .crash-subtitle {
        font-family: 'Anton', sans-serif;
        font-weight: 400;
        font-style: normal;
        font-size: 24px;
        line-height: 100%;
        letter-spacing: 0%;
        color: #ffffff;
        margin: 0;
        padding: 0;
        white-space: nowrap;
        display: inline-block;
    }

    .crash-banner {
        width: 100%;
        max-width: 100%;
        height: auto;
        display: block;
        object-fit: cover;
        position: relative;
        z-index: 1;
    }

    .crash .crash-container {
        width: 1120px;
        max-width: 100%;
        border-radius: 20px;
       /* background: var(--bg-primary-dark);*/
       /* box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.8), inset 0px 1px 0px rgba(255, 255, 255, 0.1);*/
       /* border: 1px solid var(--accent-yellow);*/
        position: relative;
        z-index: 1;
        margin: 0 auto;
    }

    /* Same layout as homepage: wrapper only adds vertical spacing; Payment uses its own margin/padding */
    .crash-payment-content {
        width: 100%;
        margin: 40px 0 0 0;
        position: relative;
        z-index: 1;
    }


    .crash .container-loading {
        display: flex;
        justify-content: space-between;
        padding: 15px;
        flex-direction: row-reverse;
    }

    .crash .loading-element {
        height: 510px;
        position: relative;
        border-radius: 20px;
        background: linear-gradient(135deg, #1a1a1a 0%, #0a0a0a 100%);
        border: 1px solid rgba(255, 255, 255, 0.1);
        overflow: hidden;
    }

    .crash .loading-element:nth-child(1) {
        width: 275px;
    }

    .crash .loading-element:nth-child(2) {
        width: calc(100% - 290px);
    }

    .crash .loading-element::after {
        width: 100%;
        height: 100%;
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        animation-name: loading_animation;
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-iteration-count: infinite;
        background: linear-gradient(to right, #ffffff00 0%, rgba(255, 255, 255, 0.1) 50%, #ffffff00 100%);
    }

    .crash .container-loading.fade-leave-active {
        transition: opacity 0.5s;
    }

    .crash .container-loading.fade-leave-to {
        opacity: 0;
    }

    .crash .container-data {
        display: flex;
        justify-content: space-between;
        padding: 15px;
        gap: 20px;
    }

    .crash .container-data.fade-enter-active {
        transition: opacity 0.5s;
    }

    .crash .container-data.fade-enter-from {
        opacity: 0;
    }

    .crash .data-left {
        flex: 1;
        width: calc(100% - 360px);
        position: relative;
        background: url('../assets/img/crash/crashSpace.jpg') no-repeat center center;
        background-size: cover;
        background-position: center;
        border-radius: 20px;
        padding: 20px;
        box-sizing: border-box;
        min-height: 510px;
    }

    @keyframes loading_animation {
        0% { transform: translateX(-100%); }
        50% { transform: translateX(100%); }
        100% { transform: translateX(100%); }
    }

    /* Mobile: hide entire banner section (image + title) */
    @media only screen and (max-width: 1024px) {
        .crash-banner-section {
            display: none !important;
        }
    }

    @media only screen and (max-width: 1140px) {
        .crash-banner-section {
            margin-bottom: 15px;
            padding: 0 var(--spacing-md);
        }

        .crash-title-container {
            left: var(--spacing-md);
            gap: 15px;
            margin: 30px 0 0 5px;
        }

        .crash-title {
            font-size: 48px;
            line-height: 52px;
        }

        .crash-subtitle {
            font-size: 18px;
        }

        .crash .crash-container {
            width: 100%;
            margin: 0 10px;
        }

        .crash-payment-content {
            width: 100%;
            margin: 40px 0 0 0;
        }
    }

    @media only screen and (max-width: 950px) {
        .crash-banner-section {
            padding: 0 var(--spacing-sm);
        }

        .crash-title-container {
            left: var(--spacing-sm);
            gap: 12px;
            margin: 30px 0 0 5px;
        }

        .crash-title {
            font-size: 36px;
            line-height: 40px;
        }

        .crash-subtitle {
            font-size: 16px;
        }

        .crash-payment-content {
            margin: 40px 0 0 0;
        }
    }

    @media only screen and (max-width: 480px) {
        .crash-banner-section {
            padding: 0 var(--spacing-xs);
        }

        .crash-title-container {
            left: var(--spacing-xs);
            gap: 10px;
            margin: 30px 0 0 5px;
        }

        .crash-title {
            font-size: 28px;
            line-height: 32px;
        }

        .crash-subtitle {
            font-size: 14px;
        }

        .crash-payment-content {
            margin: 40px 0 0 0;
        }
    }

    @media only screen and (max-width: 950px) {
        .crash-banner-section {
            margin-bottom: 10px;
        }

        .crash {
            padding: 12px 10px 12px 10px;
        }

        .crash .container-loading,
        .crash .container-data {
            flex-direction: column-reverse;
            padding: 8px;
            gap: 10px;
            margin-top: 70px;
        }

        .crash .loading-element {
            width: 100%!important;
        }

        .crash .loading-element:nth-child(1) {
            height: 200px;
            margin-top: 0;
        }

        .crash .loading-element:nth-child(2) {
            height: 510px;
            margin-top: 0;
        }

        .crash .data-left {
            width: 100%;
            padding: 10px;
            display: flex;
            flex-direction: column;
            min-height: 0 !important;
        }

        /* Mobile: History first (past results), then Game (multiplier + graph) */
        .crash .data-left .crash-history {
            order: 1;
            margin-top: 0;
            margin-bottom: 8px;
            min-height: 36px;
            height: auto;
        }

        .crash .data-left .crash-game {
            order: 2;
            flex: 1;
            min-height: 220px;
        }
    }

    @media only screen and (max-width: 480px) {
        .crash-banner-section {
            margin-bottom: 8px;
        }

    }
</style>
